<template>
  <div class="wrapper">
    <div class="modal-question" v-show="showModal">
      <div class="__body-contents">
        <router-link to="/">
          <img src="../assets/images/logo/new_logo.svg" />
        </router-link>
        <h1>
          Welcome to
          <b>Consultified</b>
        </h1>
        <h5 v-if="isfromProject">
          You need to register to Consultified to confirm your participation to the
          project.
        </h5>
        <h5 v-else-if="isfromEmployment">
          You need to register to Consultified to confirm.
        </h5>

        <div class="chech-box">
          <input type="checkbox" id="check" disabled="true" v-model="check" />
          <label for="check">Accept</label>
          <label class="colored" @click="showTerms = !showTerms">Terms & Conditions</label>
        </div>
        <img src="../assets/icons/crazy__people.svg" />

        <button class="register-btn" @click="$router.push({ name: 'signup' })">
          Register
        </button>

        <p class="have-account">
          I already have an account,
          <a href="/login" @click.prevent="$router.push({ name: 'login' })">Login</a>
        </p>
        <div class="loader" v-show="loading">
          <img src="@/assets/icons/loading_blue.gif" alt />
        </div>
      </div>
    </div>
    <div class="terms-conditions" v-show="showTerms">
      <div class="widget-body">
        <div class="info-panel">
          <button class="back-btn" @click="() => {
              (showModal = true), (showTerms = false);
            }
            ">
            <img src="../assets/icons/back__ic.svg" />
            <span>Back</span>
          </button>
          <img src="../assets/images/logo/logo__dark.svg" class="grey_logo" />
          <img src="../assets/icons/termz2.svg" class="terms_svg" />
          <div class="bottom">
            <button class="__transparent" @click="() => {
                (showModal = true), (showTerms = false);
              }
              ">
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "account_invitation",
  data() {
    return {
      showModal: true,
      check: true,
      showTerms: false,
      loading: false,
    };
  },
  methods: {
    signup(sign_type) {
      let vm = this;
      vm.loading = true;
      this.$cookies.set("account-type", 1);
      if (sign_type == "linkedin") {
        this.$store
          .dispatch("AUTH_LINKEDIN_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "google") {
        this.$store
          .dispatch("AUTH_GOOGLE_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      } else if (sign_type == "facebook") {
        this.$store
          .dispatch("AUTH_FACEBOOK_SIGNUP_REQUEST", {})
          .then((responce) => {
            vm.loading = false;
          });
      }
    },
  },
  mounted() { },
  computed: {
    isfromProject() {
      return this.$route.params.type === "project";
    },
    isfromEmployment() {
      return this.$route.params.type === "employment";
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  position: relative;
  min-height: 100%;
  text-align: center;
  overflow: hidden;
  background: #f2f2f2 url("../assets/images/backgrounds/logo_stamp2.svg");
  background-size: contain;
  z-index: 999999;
  background-repeat: no-repeat !important;
  background-position: center;
}

.__container {
  position: relative;
  display: inline-block;

  @media (min-width: 300px) and (max-width: 630px) {}

  .form {
    display: flex;
    align-items: center;
    flex-direction: column;

    .logo {
      margin-top: 40px;

      h2 {
        color: #1885ad !important;
      }

      @media (min-width: 300px) and (max-width: 630px) {
        position: relative;
        top: -10px;
      }
    }

    .login_form {
      margin-top: 40px;
      text-align: left;

      @media (min-width: 300px) and (max-width: 630px) {
        padding-left: 20px;
        padding-right: 20px;
      }

      .label-password {
        margin-top: 30px;
      }

      label {
        color: #000;
        font-weight: lighter;
        font-size: 14px;
        margin-bottom: 5px;
        margin-left: 20px;
      }

      .email {
        background: url(../assets/icons/mail.png) right;
      }

      .password {
        background: url(../assets/icons/key.png) right;
      }

      .signup {
        color: #fff !important;
        margin-top: 20%;
        align-self: center;
        cursor: pointer;
        margin-bottom: 10px;
      }

      div {
        margin-bottom: 20px;
      }
    }

    .logo,
    .login_form {
      display: flex;
      flex-direction: column;
    }

    .banner {
      margin-top: 30px;
    }

    .banner span {
      font-size: 16px;
      color: #000000;
      margin-top: 20% !important;
      font-weight: lighter !important;
    }

    .banner h1 {
      font-weight: normal;
      text-align: center;
      font-size: 30px;
      color: #1ba5a4;
      margin-bottom: 20% !important;
    }
  }
}

.modal-question {
  position: absolute;
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  padding: 20px 50px;
  border: 0.5px rgba(112, 112, 112, 0.9);

  .__body-contents {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .loader {
      img {
        width: 40px;
      }
    }

    p {
      font-family: "Nunito", sans-serif;
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.36;
      letter-spacing: 0px;
      text-align: center;
      color: #031019;
    }

    button {
      width: 284px;
      height: 36px;
      border-radius: 18px;
      margin: 20px 0;
      color: #fff;
      background-image: linear-gradient(267deg, #1885ad, #00a3a8);
      outline: none;
      cursor: pointer;

      &:disabled {
        background: #8d8d8d;
        opacity: 0.5;
      }
    }

    .register-btn {
      width: 291px;
      height: 45px;
      background: transparent linear-gradient(109deg, #1ba5a4 0%, #2f90b6 100%) 0% 0% no-repeat padding-box;
      border-radius: 5px !important;
      color: white;
    }

    h1 {
      font-family: "Nunito", sans-serif;
      font-size: 23px;
      font-weight: 300;
      font-stretch: normal;
      margin: 20px;
      font-style: normal;
      line-height: 1.35;
      letter-spacing: 0.01px;
      text-align: center;
      color: #4d4d4d;

      .b {}
    }

    h5 {
      font-family: "Nunito", sans-serif;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.36;
      letter-spacing: 0px;
      text-align: center;
      color: #808080;
    }

    .chech-box {
      margin: 15px 0 30px 0;
      display: flex;

      input {
        margin-top: 3px;
        margin-right: 10px;
      }

      label {
        font-family: "Nunito", sans-serif;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.36;
        letter-spacing: 0px;
        text-align: center;
        color: #000000;
      }

      .colored {
        cursor: pointer;
        text-decoration: underline;
        margin-left: 10px;
        color: #1890a9;
      }
    }

    a {
      text-decoration: none;
      font-size: 16px;
      color: #0e9695;
    }

    .register-intro {
      color: #1ba5a4;
      font-family: "Nunito", sans-serif;
      font-size: 15px;
      font-weight: 800;
      margin-bottom: 5px;
      margin-top: 20px;
    }

    .social-media-list.disabled {
      opacity: 0.3;
    }

    .social-media-list {
      list-style: none;
      display: grid;
      margin-bottom: 20px;
      background: #f2f2f2;
      grid-column-gap: 8px;
      grid-template-columns: 32% 32% 32%;
      padding: 8px;
      width: 323px;
      border-radius: 5px;

      li {
        a {
          display: flex;
          justify-content: center;
        }
      }

      li.linkedin {
        a {
          display: flex;
          align-items: center;
          background: #fff;
          padding: 3px 7px;
          border-radius: 5px;

          span {
            margin-top: 2px;
            margin-left: 3px;
            color: #3773bb;
            font-size: 13px;
          }
        }
      }

      li.google {
        a {
          display: flex;
          align-items: center;
          background: #fff;
          padding: 3px 7px;
          border-radius: 5px;

          span {
            margin-top: 2px;
            margin-left: 3px;
            font-size: 13px;
          }
        }
      }

      li.facebook {
        a {
          display: flex;
          align-items: center;
          background: #4765a3;
          padding: 3px 7px;
          border-radius: 5px;

          span {
            margin-top: 2px;
            margin-left: 3px;
            color: #fff;
            font-size: 13px;
          }
        }
      }
    }

    .have-account {
      color: #6c6c6c;

      a {
        color: #1ba5a4;
        font-weight: 800;
        text-decoration: none;
      }
    }
  }
}

.cover__body {
  background: #fff;
  padding: 20px;
  overflow: scroll;
  height: 500px;
}

.terms-conditions {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .widget-body {
    height: 100%;
    background: #efefef 0% 0% no-repeat padding-box;
    display: flex;
    justify-content: center;
    overflow-y: auto;
    padding-top: 50px;
    padding-bottom: 20px;

    .info-panel {
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 1px solid rgb(226, 226, 226);
      border-radius: 5px;
      width: 800px;
      padding-top: 40px;
      padding-bottom: 20px;
      padding-left: 100px;
      padding-right: 100px;
      display: inline-table;
      position: relative;

      .back-btn {
        position: absolute;
        top: 14px;
        outline: none;
        border: none;
        left: 14px;
        text-decoration: none;
        color: #2991b8;

        span {
          margin-left: 7px;
        }

        img {}
      }

      img.grey_logo {
        margin: 20px 0;
        float: left;
        width: 70px;
        height: 65px;
      }

      img.terms_svg {
        width: 100%;
        display: block;
        margin-top: 20px;
      }

      .bottom {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        button {
          outline: none;
        }

        .__accept {
          font-size: 14px;
          width: 280px;
          height: 25px;
          border-radius: 18px;
          color: #fff;
          background-image: linear-gradient(267deg, #1885ad, #00a3a8);

          outline: none;
          cursor: pointer;
        }

        .__transparent {
          margin-top: 10px;
          color: #2991b8;
        }
      }
    }
  }
}</style>